import { useState, useContext, useEffect } from "react";
import { PostContext } from "../../providers/PostContext";
import { FeedContent } from "../../components/Feed";

export const Ultimas = () => {
  const [page, setPage] = useState<number>(1),
    [loading, setLoading] = useState(false);

  const { posts, loadPosts } = useContext(PostContext);

  useEffect(() => {
    const handleLoadPosts = async () => {
      setLoading(true);

      await loadPosts(page);

      setLoading(false);
    };

    handleLoadPosts();
  }, [page]);

  return <FeedContent setPage={setPage} posts={posts} loading={loading} />;
};
